import React, { useState, useEffect, useRef } from "react";

const Participant = ({
  participant,
  muteAudio,
  remoteTracks,
  videoStyle
}) => {
  const [videoTracks, setVideoTracks] = useState([]);
  const [audioTracks, setAudioTracks] = useState([]);

  const videoRef = useRef();
  const audioRef = useRef();

  const trackpubsToTracks = (trackMap) =>
    Array.from(trackMap.values())
      .map((publication) => publication.track)
      .filter((track) => track !== null);

  useEffect(() => {
    const trackSubscribed = (track) => {
      if (track.kind === "video") {
        setVideoTracks((videoTracks) => [...videoTracks, track]);
        if (remoteTracks) {
          track.on("disabled", () => {
            remoteTracks("video", true);
          });

          track.on("enabled", () => {
            remoteTracks("video", false);
          });
        }
      } else {
        setAudioTracks((audioTracks) => [...audioTracks, track]);
        if (remoteTracks) {
          track.on("disabled", () => {
            remoteTracks("audio", true);
          });

          track.on("enabled", () => {
            remoteTracks("audio", false);
          });
        }
      }
    };

    const trackUnsubscribed = (track) => {
      if (track.kind === "video") {
        setVideoTracks((videoTracks) => videoTracks.filter((v) => v !== track));
      } else {
        setAudioTracks((audioTracks) => audioTracks.filter((a) => a !== track));
      }
    };

    setVideoTracks(trackpubsToTracks(participant.videoTracks));
    setAudioTracks(trackpubsToTracks(participant.audioTracks));

    participant.on("trackSubscribed", trackSubscribed);
    participant.on("trackUnsubscribed", trackUnsubscribed);

    return () => {
      setVideoTracks([]);
      setAudioTracks([]);
      participant.removeAllListeners();
    };
  }, [participant]);

  useEffect(() => {
    const videoTrack = videoTracks[0];
    if (videoTrack) {
      videoTrack.attach(videoRef.current);
      return () => {
        videoTrack.detach();
      };
    }
  }, [videoTracks]);

  useEffect(() => {
    const audioTrack = audioTracks[0];
    if (audioTrack) {
      try {
        audioTrack.attach(audioRef.current);
      } catch (error) {}
      return () => {
        try {
          audioTrack.dettach(audioRef.current);
        } catch (error) {}
      };
    }
  }, [audioTracks]);

  return (
    <div>
      <video ref={videoRef} autoPlay={true} style={videoStyle} />
      <audio ref={audioRef} autoPlay={true} muted={muteAudio} />
    </div>
  );
};

export default Participant;
